import axiosInstance from '@/services/axiosInstance'
import store from '@/store'
import mock from '@/services/mock/index'

async function getNotifications (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getNotifications
      const pages = data.data.length
      const sinrecoger = data.data.filter(d => d.status === 'Sin recoger').length
      const descargando = data.data.filter(d => d.status === 'Descargando').length
      const descargados = data.data.filter(d => d.status === 'Descargada').length
      const tramitadas = data.data.filter(d => d.status === 'Tramitada').length
      store.commit('notifications/setNotificationsNumber', { sinrecoger: sinrecoger, descargando: descargando, descargados: descargados, tramitadas: tramitadas })

      const clone = JSON.parse(JSON.stringify(data))
      if (params !== null) {
        if (params.status && params.status !== 'Todas') {
          clone.data = clone.data.filter(d => d.status === params.status)
          console.log(clone.data)
        }
        clone.data = clone.data.slice(0, params.limit)
      }

      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/NEO/getneopublicadaspag',
      method: 'POST',
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getNotifications }
